import React from "react";
import { portfolioData as DATA } from "../../data/portfolioData";
import Badge from "../ui/Badge";
import Card from "../ui/Card";
import { SiAmazonwebservices } from "react-icons/si";
import { TbBrandPython } from "react-icons/tb";
import { FaCogs } from "react-icons/fa";
import { HiOutlineBolt, HiOutlineMagnifyingGlass } from "react-icons/hi2";

export default function Hero() {
  return (
    <div className="relative overflow-hidden" id="top">
      {/* Animated Wave Background */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        {/* Gradient Base */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#0b0b25] via-[#07071a] to-[#050510]" />

        {/* Wave SVG */}
        <svg
          className="absolute bottom-0 left-0 h-[60%] w-[200%] animate-waveSlow opacity-30"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path
            fill="url(#waveGradient)"
            d="M0,192L60,186.7C120,181,240,171,360,160C480,149,600,139,720,149.3C840,160,960,192,1080,202.7C1200,213,1320,203,1380,197.3L1440,192L1440,320L0,320Z"
          />
          <defs>
            <linearGradient id="waveGradient" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#6366f1" stopOpacity="0.6" />
              <stop offset="100%" stopColor="#d946ef" stopOpacity="0.6" />
            </linearGradient>
          </defs>
        </svg>

        {/* Second wave for depth */}
        <svg
          className="absolute bottom-0 left-0 h-[70%] w-[200%] animate-waveFast opacity-20"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path
            fill="#6366f1"
            d="M0,160L80,170C160,180,320,200,480,186.7C640,173,800,128,960,128C1120,128,1280,173,1360,197.3L1440,224L1440,320L0,320Z"
          />
        </svg>
      </div>

      <div className="relative mx-auto max-w-6xl px-4 py-14 md:py-20">
        <div className="grid gap-10 md:grid-cols-12 md:items-center">
          <div className="md:col-span-7">
            <div className="flex flex-wrap gap-2">
              <Badge icon={SiAmazonwebservices}>AWS</Badge>
              <Badge icon={FaCogs}>MLOps</Badge>
              <Badge icon={HiOutlineMagnifyingGlass}>RAG</Badge>

              <Badge icon={TbBrandPython}>Python</Badge>
              <Badge icon={HiOutlineBolt}>PySpark</Badge>
            </div>

            <h1 className="mt-5 text-4xl font-semibold leading-tight text-white md:text-5xl">
              {DATA.title} |{" "}
              <span className="text-indigo-300">
                RAG, MLOps & AWS Deployments
              </span>
            </h1>

            <p className="mt-4 max-w-2xl text-lg text-white/70">
              {DATA.tagline}
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href="#projects"
                className="rounded-xl bg-indigo-500 px-4 py-2.5 text-sm font-semibold text-white shadow-glow hover:bg-indigo-400"
              >
                View Projects
              </a>
              <a
                href={`mailto:${DATA.email}`}
                className="rounded-xl border border-white/10 bg-white/5 px-4 py-2.5 text-sm font-semibold text-white hover:bg-white/10"
              >
                Contact
              </a>
            </div>

            <div className="mt-6 flex flex-wrap gap-4 text-sm text-white/70">
              <span>📧 {DATA.email}</span>
            </div>
          </div>

          <div className="md:col-span-5">
            <Card className="relative overflow-hidden">
              <div className="absolute right-4 top-4 animate-floaty rounded-2xl border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
                Building AI systems end-to-end
              </div>

              <div className="text-sm text-white/70">Impact snapshot</div>

              <div className="mt-4 grid grid-cols-2 gap-3">
                {DATA.highlights.map((h) => (
                  <div
                    key={h.k}
                    className="rounded-xl border border-white/10 bg-black/20 p-4"
                  >
                    <div className="text-lg font-semibold text-white">
                      {h.k}
                    </div>
                    <div className="mt-1 text-xs text-white/70">{h.v}</div>
                  </div>
                ))}
              </div>

              <div className="mt-4 rounded-xl border border-white/10 bg-white/5 p-4">
                <div className="text-xs uppercase tracking-widest text-white/60">
                  Core focus
                </div>
                <div className="mt-2 flex flex-wrap gap-2">
                  {[
                    "RAG Chatbots",
                    "ETL Pipelines",
                    "LLM Tuning",
                    "FastAPI Deployments",
                    "CI/CD",
                  ].map((x) => (
                    <Badge key={x}>{x}</Badge>
                  ))}
                </div>
              </div>
              {/* Credly Badge - Bottom */}
              <div className="mt-6 flex justify-center border-t border-white/10 pt-4">
                <a
                  href="https://www.credly.com/badges/0e646790-37ce-4352-9775-029747ba2ae8/public_url"
                  target="_blank"
                  rel="noreferrer"
                  className="transition hover:scale-105"
                >
                  <img
                    src="https://images.credly.com/images/384f526e-2785-408e-9d1f-c9b33e0f40d7/image.png"
                    alt="Credly Badge"
                    className="h-20 opacity-90 hover:opacity-100"
                  />
                </a>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
